import Head from "next/head";
import { ToastContainer } from "react-toastify";

//internal import
import Navbar from "@layout/navbar/Navbar";
import Footer from "@layout/footer/Footer";
import FooterTop from "@layout/footer/FooterTop";
import MobileFooter from "@layout/footer/MobileFooter";
import FeatureCard from "@component/feature-card/FeatureCard";
import NavBarTop from "./navbar/NavBarTop";
import { useEffect, useRef, useState } from "react";
import Search from "@component/search/Search";
// import Script from "next/script";
import { useRouter } from "next/router";

const Layout = ({ title, description, children }) => {
  const [checkSearch, setChackSearch] = useState("");
  const [mobileMainNav, setMobileMainNav] = useState(true);

  const toggleMobileNavSearch = () => {
    setMobileMainNav(!mobileMainNav);
  };

  const router = useRouter();

  useEffect(() => {
    setChackSearch("");
  }, [router]);

  useEffect(() => {
    // if (checkSearch !== "") {
    window.scrollTo(0, 0);
    // }
  }, [checkSearch]);
  return (
    <>
      <ToastContainer />
      <div className="font-sans">
        <Head>
          <title>
            {title ? `${title} | CubeNation` : "Cube Nation - Bangladesh's Speed Cube collection & Twisty Puzzle Bazaar"}
          </title>
          {description && <meta name="description" content={description} />}
          <link ref="icon" href="/favicon.png" />
        </Head>

        <Navbar
          mobileMainNavState={{ mobileMainNav, setMobileMainNav }}
          checkSearch={checkSearch}
          setChackSearch={setChackSearch}
        />
        {checkSearch === "" && <div className="bg-gray-50">{children}</div>}
        {checkSearch !== "" && (
          <div className="bg-gray-50">
            <Search checkSearch={checkSearch} />
          </div>
        )}

        <MobileFooter toggleMobileNavSearch={toggleMobileNavSearch} />
        <div className="w-full">
          <FooterTop />
          <div className="hidden relative lg:block mx-auto max-w-screen-2xl py-6 px-3 sm:px-10">
            <FeatureCard />
          </div>
          <hr className="hr-line"></hr>
          <div className="border-t border-gray-100 w-full ">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
